import { Component, inject, ViewChild } from '@angular/core';
import { effect } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '@/components/dialog/dialog.component';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { DialogObject } from '@/components/dialog/dialog.types';
import { getDynamicDocumentsDataTableStructure } from './utils/document-dynamics-datatable';
import { DataTableRowActions, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { DocumentDynamicsService } from './document-dynamics.service';
import { DynaDocsResponse } from '@/types';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { createServerQuery } from '@/components/data-table-builder/server-query';

@Component({
  selector: 'sm-document-dynamics',
  templateUrl: './document-dynamics.component.html',
  styleUrl: './document-dynamics.component.scss',
  imports: [PageHeaderComponent, DataTableBuilderComponent, ButtonModule, CommonModule, TranslateModule],
})
export class DocumentDynamicsComponent {
  messageService = inject(MessageService);
  documentDynamicsService = inject(DocumentDynamicsService);
  private translate = inject(TranslateService);

  router = inject(Router);

  breadcrumb = [
    {
      label: 'settings.refParams.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'Document dynamics',
      routerLink: ['/settings', 'document-dynamics'],
    },
  ];

  loading = false;
  title: string = this.translate.instant('dynamicDocument.title');

  @ViewChild('dialog') dialogComponent!: DialogComponent;
  dacDialog?: DialogObject;

  rowActions: DataTableRowActions = {
    defaultActions: {
      edit: {
        label: 'Modifier',
      },
      delete: {
        label: 'Supprimer',
      },
    },
    editAction: doc => {
      this.router.navigate(['/settings/manage-document-dynamics', doc.id]);
    },
    deleteAction: () => {
      // this.documentDynamicsService.deleteDac(doc.id).subscribe({
      //   next: () => {
      //     this.messageService.add({
      //       severity: 'success',
      //       summary: 'Success',
      //       detail: 'Document deleted successfully',
      //     });
      //     this.ngOnInit(); // Refresh the list after deletion
      //   },
      //   error: error => {
      //     this.messageService.add({
      //       severity: 'error',
      //       summary: 'Error deleting document',
      //       detail: error.message,
      //     });
      //   },
      // });
    },
  };

  data: DynaDocsResponse[] = [];
  totalRecords = 0;
  serverQuery = createServerQuery({});
  datatableObject: DynamicDataTable = {
    ...getDynamicDocumentsDataTableStructure({
      rowActions: this.rowActions,
      createAction: () => {
        this.router.navigate(['/settings/manage-document-dynamics']);
      },
    }),
    enableServerActions: true,
    serverQuery: this.serverQuery,
  };

  constructor() {
    let firstRun = true;

    effect(() => {
      const page = this.serverQuery.page();
      const size = this.serverQuery.pageSize();
      const sortBy = this.serverQuery.sortBy();
      const sortOrder = this.serverQuery.sortOrder();
      const search = this.serverQuery.search();
      const sort = sortBy ? `${sortBy},${sortOrder}` : '';
      const filter = this.serverQuery.filterString();

      if (firstRun) {
        firstRun = false;
        return;
      }

      this.loadData(page, size, search, sort, filter);
    });
  }

  private loadData(page = 0, size = 10, search = '', sort = '', filter = '') {
    this.loading = true;
    this.documentDynamicsService.getDynaDocs({ page, size, search, sort, filter }).subscribe({
      next: docs => {
        this.data = docs.content;
        this.totalRecords = (docs as any).total ?? docs.content?.length ?? 0;
        this.datatableObject.data = this.data;
        this.loading = false;
      },
      error: error => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error loading documents',
          detail: error.message,
        });
      },
    });
  }
}
